import moment from 'moment';

const service = [
    'SimpleApiFactory',
    '$resource',
    '$rootScope',
];

const fn = (
    SimpleApiFactory,
    $resource,
    $rootScope
) => {
    const F = {};

    F.data = [];

    F.resource = function() {
        return $resource('/api/public/release', {id: '@id'});
    };

    F.fetch = function() {
        return F.resource().get({}, (response) => {
            const parsedResponse = SimpleApiFactory.parse(response);

            if(!parsedResponse.status) {
                return console.error('Unable to fetch Releases.');
            }

            F.data = response.data;

            $rootScope.$emit('ReleasesFetched');
        }, (body) => {
            console.error('Unable to fetch Releases.', body);
        });
    };

    F.getAll = function() {
        return angular.copy(F.data);
    };

    F.findById = function(id) {
        return F.getAll().find((release) => release.id === +id);
    };

    F.getByProduct = function(id) {
        const _id = +id;

        return F.getAll().filter((release) => {
            return +release.product_id === _id;
        });
    };

    F.humanizeDate = function(input) {
        return moment(input).format('D MMMM YYYY');
    };

    const findInProperties = function(release, properties, searchFor) {
        return !!properties.find((property) => {
            return release[property] && release[property].toString().toLowerCase().includes(searchFor);
        });
    };

    F.search = (searchFor, setOfReleases) => {
        const releases = setOfReleases ? setOfReleases : F.data;

        return angular.copy(releases).filter((release) => {
            const propertiesToSearch = [
                'version',
                'release_notes',
            ];

            const _searchFor = searchFor.toLowerCase();

            if(findInProperties(release, propertiesToSearch, _searchFor)) {
                return true;
            }

            return false;
        });
    };

    return F;
};

service.push(fn);

export default service;



// WEBPACK FOOTER //
// ./resources/assets/app-releases/services/ReleasesFactory.js